import { headDataContacts } from "@/utils/mockData/userMocks";
import { IContactData } from "@/models/contact";
import HeadSection from "../common/HeadSection";
import Brochures from "../home/brochures/Brochures";
import ContactInfo from "./ContactInfo";

const ContactBody = ({ contactsData }: { contactsData?: IContactData }) => {
    return (
        <div className="minWidth100vwFromXL">
            <HeadSection
                className="mb-5"
                content={headDataContacts(contactsData?.headImage)}
                wordingsDelta={contactsData?.wordings}
            />
            <ContactInfo contactsData={contactsData} />
            <Brochures />
        </div>
    );
};

export default ContactBody;
